exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button:focus {\n  outline: 0; }\n\n.navbar .dropdown-menu .form-control {\n  width: 200px; }\n\n.navbar .nav-item .img-circle {\n  border-radius: 50%;\n  margin: 10px; }\n\n.navbar .nav-item {\n  margin: 1px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/shared/layout/header.component.scss
// module id = ../../../../../src/app/shared/layout/header.component.scss
// module chunks = main